import React, { useEffect, useState } from 'react';
import { Card, Table, Button } from 'react-bootstrap';
import { getFirestore, collection, addDoc, onSnapshot, query, orderBy } from 'firebase/firestore'; // needed

const TeacherAttendance = () => {
  const [attendance, setAttendance] = useState([]);
  const [form, setForm] = useState({ name: '', department: '', status: 'Present', inTime: '', outTime: '' });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ name: '', department: '', date: '', status: '' });

  useEffect(() => {
    const db = getFirestore();
    const q = query(collection(db, 'teacherAttendance'), orderBy('timestamp', 'desc'));
    const unsub = onSnapshot(q, (snapshot) => {
      setAttendance(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });
    return () => unsub();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const db = getFirestore();
      await addDoc(collection(db, 'teacherAttendance'), {
        ...form,
        date: new Date().toISOString().slice(0, 10),
        timestamp: Date.now(),
      });
      setForm({ name: '', department: '', status: 'Present', inTime: '', outTime: '' });
    } catch (err) {
      alert('Error saving attendance: ' + err.message);
    }
    setLoading(false);
  };

  const [highlight, setHighlight] = useState(-1);
  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setHighlight(i);
      i = (i + 1) % attendance.length;
    }, 1200);
    return () => clearInterval(interval);
  }, [attendance]);

  const filteredAttendance = attendance.filter(row =>
    row.name.toLowerCase().includes(filters.name.toLowerCase()) &&
    row.department.toLowerCase().includes(filters.department.toLowerCase()) &&
    (filters.date ? row.date === filters.date : true) &&
    (filters.status ? row.status === filters.status : true)
  );

  return (
    <div style={{padding: 0}}>
      <h2 style={{ fontWeight: 700, marginBottom: 24 }}>Teacher Attendance (Real-Time, DB)</h2>
      <Card style={{ borderRadius: 16, boxShadow: '0 4px 24px rgba(25,118,210,0.10)', marginBottom: 24 }}>
        <Card.Body>
          <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 16, marginBottom: 24, flexWrap: 'wrap' }}>
            <input required value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} placeholder="Teacher Name" style={{ borderRadius: 8, border: '1px solid #ccc', padding: 8, minWidth: 120 }} />
            <input required value={form.department} onChange={e => setForm(f => ({ ...f, department: e.target.value }))} placeholder="Department" style={{ borderRadius: 8, border: '1px solid #ccc', padding: 8, minWidth: 100 }} />
            <input required type="time" value={form.inTime} onChange={e => setForm(f => ({ ...f, inTime: e.target.value }))} placeholder="In Time" style={{ borderRadius: 8, border: '1px solid #ccc', padding: 8, minWidth: 100 }} />
            <input required type="time" value={form.outTime} onChange={e => setForm(f => ({ ...f, outTime: e.target.value }))} placeholder="Out Time" style={{ borderRadius: 8, border: '1px solid #ccc', padding: 8, minWidth: 100 }} />
            <select value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} style={{ borderRadius: 8, border: '1px solid #ccc', padding: 8 }}>
              <option value="Present">Present</option>
              <option value="Absent">Absent</option>
              <option value="Late">Late</option>
            </select>
            <Button type="submit" disabled={loading} style={{ borderRadius: 8, fontWeight: 600 }}>{loading ? 'Saving...' : 'Add Attendance'}</Button>
          </form>
          {/* Filters */}
          <div style={{ display: 'flex', gap: 12, marginBottom: 16, flexWrap: 'wrap' }}>
            <input value={filters.name} onChange={e => setFilters(f => ({ ...f, name: e.target.value }))} placeholder="Filter Name" style={{ borderRadius: 8, border: '1px solid #ccc', padding: 6, minWidth: 100 }} />
            <input value={filters.department} onChange={e => setFilters(f => ({ ...f, department: e.target.value }))} placeholder="Filter Department" style={{ borderRadius: 8, border: '1px solid #ccc', padding: 6, minWidth: 80 }} />
            <input type="date" value={filters.date} onChange={e => setFilters(f => ({ ...f, date: e.target.value }))} style={{ borderRadius: 8, border: '1px solid #ccc', padding: 6 }} />
            <select value={filters.status} onChange={e => setFilters(f => ({ ...f, status: e.target.value }))} style={{ borderRadius: 8, border: '1px solid #ccc', padding: 6 }}>
              <option value="">All Status</option>
              <option value="Present">Present</option>
              <option value="Absent">Absent</option>
              <option value="Late">Late</option>
            </select>
          </div>
          <Table responsive hover size="sm" style={{ background: '#fff', borderRadius: 10, fontSize: 16 }}>
            <thead>
              <tr style={{ background: '#f5f7fa' }}>
                <th>Name</th>
                <th>Department</th>
                <th>Date</th>
                <th>Status</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {filteredAttendance.map((row, i) => (
                <tr key={row.id} style={{ background: highlight === i ? '#e3f2fd' : 'none', transition: 'background 0.5s' }}>
                  <td style={{ fontWeight: 600 }}>{row.name}</td>
                  <td>{row.department}</td>
                  <td>{row.date}</td>
                  <td>
                    <span style={{
                      color: row.status === 'Present' ? '#43a047' : row.status === 'Absent' ? '#d32f2f' : '#fbc02d',
                      fontWeight: 700,
                      letterSpacing: 1,
                      animation: highlight === i ? 'pulse 1s infinite alternate' : 'none',
                    }}>{row.status}</span>
                  </td>
                  <td>{row.inTime || '--'} - {row.outTime || '--'}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
      <style>{`
        @keyframes pulse {
          0% { filter: brightness(1); }
          100% { filter: brightness(1.3); }
        }
      `}</style>
    </div>
  );
};

export default TeacherAttendance;
